import L from 'leaflet'
import { map, layerGroup } from './mapManager'
import { length } from '@turf/turf'
import "leaflet-polylinedecorator"
import PolylineTooltip from "../components/main/PolylineTooltip.vue"
import { returnVueComponentElement } from './vueUtil'

//线段标绘部分

const polylineOpt = {
    color: 'blue',
    weight: 10,
    description: '',
}

//线上面的纹理
const marker = L.Symbol.marker({
    rotate: true,//是否旋转，false marker 始终方向一致，true marker 会随着线的方向发生改变
    markerOptions: {
        icon: L.icon({
            iconUrl: './static/icons/arrow.png',
            iconAnchor: [8, 8],
            iconSize: [16, 16],
        })
    }
})


let polyline = null
let lastPolyline = null
let tipsEl
let myPolyline


var clickEvent=function(e)
{
    addPoint(e.latlng)
}

var mouseMoveEvent=function(e)
{
    onMove(e)
}

var dblclickEvent=function(e){
    finish()
}

function start() {
    tipsEl = L.DomUtil.create('div', 'widget tips', L.DomUtil.get('map'))
    tipsEl.innerHTML = '<span>点击选取第一个点<span>'
    //设置地图的鼠标按下事件
    map.on("click", clickEvent)
    map.on("mousemove", mouseMoveEvent)
    map.on("dblclick", dblclickEvent)

}
function addPoint(latlng) {
    if (polyline == null) {
        myPolyline = L.layerGroup().addTo(layerGroup)
        polyline = L.polyline([latlng], polylineOpt).addTo(myPolyline)
        lastPolyline = L.polyline([], { color: 'red', dashArray: [10, 10] }).addTo(myPolyline)
        return
    }
    polyline.addLatLng(latlng)
}

function onMove(e) {
    let latlng = e.latlng
    L.DomUtil.setPosition(tipsEl, e.containerPoint)
    if (lastPolyline != null && polyline != null) {
        let latlngs = polyline.getLatLngs()
        let last = latlngs[latlngs.length - 1]
        let newLatlngs = [last, latlng]
        lastPolyline.setLatLngs(newLatlngs)
        getInfo()
    }
}


function getInfo() {
    let allDistance = length(polyline.toGeoJSON(), { units: 'kilometers' })
        + length(lastPolyline.toGeoJSON(), { units: 'kilometers' })
    tipsEl.innerHTML = `${allDistance.toFixed(2)}Km<br>双击结束标绘`
}

function finish() {
    let dis = length(polyline.toGeoJSON(), { units: 'kilometers' })
    let params = {
        dis,
        myPolyline
    }
    let con = returnVueComponentElement(PolylineTooltip, 'polylineTooltip', { params })
    let popup = L.popup().setContent(con)
    polyline.bindPopup(popup)
    lastPolyline.remove()

    L.polylineDecorator(polyline, {
        patterns: [
            {
                offset: 1,//第一个图标偏移
                endOffset: 1,//最后一个图标偏移
                repeat: '100',//图标间距
                symbol: marker
            }
        ]
    }).addTo(myPolyline);

    polyline = null
    tipsEl.innerHTML = '点击选择第一个点'

}

//彻底结束
function end() {
    if (tipsEl) {
        L.DomUtil.remove(tipsEl)
    }
    map.off("click",clickEvent)
    map.off("mousemove",mouseMoveEvent)
    map.off('dblclick',dblclickEvent)
}

export default {
    start,
    end
}



// WEBPACK FOOTER //
// ./src/util/plotPolyline.js